/*
 * @Desc: 文件描述
 * @Author: jiayi zhu
 * @Date: 2020-01-02 10:24:15
 * @LastEditors: lumingming
 */

module.exports = {
  HealthTask: 'https://record.iboohee.com/',
  ExerciseCheck: 'https://nice.iboohee.com/',
  AlibabaExerciseCheck: 'https://cube.iboohee.com/',
  Lottery: 'https://one.iboohee.com',
  Columbus: 'https://columbus.iboohee.com',
  Passport: 'https://passport.iboohee.com',
  Bingo: 'https://bingo.iboohee.com',
  Status: 'https://status.iboohee.com',
  qiniu_host: 'https://qa.boohee.cn/',
  Crm: 'https://crm.iboohee.cn/',
  Longan: 'https://longan.iboohee.com/',
  League: 'https://league.iboohee.com/',
  CONFIG_WATER: {
    app_key: 'b14294453777861d3b42d305',
    app_secret: '79e9371c537eb479da10a2f0734deaf6',
    host: 'https://water.iboohee.com/'
  },
  CALORY_HOST: 'https://calory.iboohee.com/',
  PIXIU_HOST: 'https://pixiu.iboohee.com/',
  FOODIE_HOST: 'https://foodie.iboohee.com/',
  SA_SERVER_URL: 'https://saapi.boohee.cn/sa?project=default',
  SEAFARER_HOST: 'https://seafarer.iboohee.com',
  GENE_BIND: 'https://healthy.iboohee.com/',
  TRUCK_HOST: 'https://truck.iboohee.com/',
  Bee: 'https://bee.iboohee.com/',
  APPInterface: 'https://api.iboohee.com/app-interface/',
  DataInterface: 'https://api.iboohee.com/data-interface/',
  Gpt: 'http://0.0.0.0:3000/',
  LLM: 'http://llm.iboohee.com/',
  BOX_CRON: 'http://box-core.iboohee.com/',
  MEMBER_HOST: 'https://member.iboohee.com/',
  api: 'https://api.iboohee.com',
  REPORT_URL: 'https://api.iboohee.com/open-interface/v1/base/front-log-report'
};
